<template>
  <div class="tri" :class="{ selected, disabled }" @click="onClick">
    <van-icon :name="selected ? selectedIcon : unselectedIcon" class="tri-icon" />
    <div class="tri-label">
      <slot>{{ label }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleRadioItem',
  props: {
    value: [String, Number, Boolean, Object, null],
    name: [String, Number, Boolean, Object],
    label: String,
    disabled: Boolean,
    selectedIcon: { type: String, default: 'passed' },
    unselectedIcon: { type: String, default: 'circle' }
  },
  computed: {
    selected() {
      return this.value === this.name;
    }
  },
  methods: {
    onClick() {
      if (this.disabled) return;
      const next = this.selected ? null : this.name;
      this.$emit('input', next);
      this.$emit('change', next);
    }
  }
}
</script>

<style scoped lang="less">
.tri {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 8px;
  border-radius: 6px;
  background: #fff;
}
.tri.selected .tri-label { color: #1989fa; }
.tri.disabled { opacity: .6; pointer-events: none; }
.tri-icon { font-size: 18px; color: #1989fa; }
.tri-label { font-size: 14px; color: #111; }
</style>



// WEBPACK FOOTER //
// src/components/mobile-ticket/ToggleRadioItem.vue